import { Box, Button } from "@mui/material";
import PowerSettingsNew from "@mui/icons-material/PowerSettingsNew";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Selectors as AdbSelectors } from "../../../redux/AdministrateurDeBien";
import LogoHeader from "../../../ressources/images/logo_vertuloo_vert.png";
import LogoV from "../../../ressources/images/logo_vertuloo_v.png";
import { Selectors as UtilisateursSelectors } from "../../../redux/Utilisateurs";
import {
  getNameToDisplay,
  logout,
} from "../../../services/Authentification/authentification";
import { ProfileIcon } from "../images";
import styles from "../styles";
import { isPathAuthorizedForUser } from "../../../services/Route";
import Types from "Types";
import { useNavigate } from "react-router";
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
const HeaderAuthenticated: React.FC = () => {
  const adbDetail = useSelector(AdbSelectors.getSelectedAdbDetail);
  const infoProfil = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getProfilUtilisateur(state)
  );

  const handleDeconnexion = () => {
    logout();
  };

  const navigate = useNavigate();
  const handleMessageRedirect = () => {
    navigate("/messages/consulter");
  }

  return (
    <Box className="headerContainerAuthenticated" sx={styles}>
      <div className="headerAuthenticated">
        <div className="logoAuthenticated">
          <a href={"/dashboard"}>
            <img
              src={LogoV}
              alt="Logo Besse Immobilier et Construction"
              width={32}
              className="logoV"
            />
            <img
              src={LogoHeader}
              alt="Logo Besse Immobilier et Construction"
              width={174}
            />
          </a>
        </div>
        <div className="menu">
          <Link to={"/dashboard"} className="menuLink">
            Home
          </Link>
          {isPathAuthorizedForUser(
            "/mes-administrateurs-de-biens",
            infoProfil
          ) && (
            <Link to={"/mes-administrateurs-de-biens"} className="menuLink">
              Administrateurs de biens
            </Link>
          )}
          {isPathAuthorizedForUser("/mes-utilisateurs", infoProfil) && (
            <Link to={"/mes-utilisateurs"} className="menuLink">
              Utilisateurs
            </Link>
          )}
          <div className="connexionContainer connexionAuthenticated">
            <div className="identifiant">
              <ProfileIcon />
              <div>
                <p>{getNameToDisplay()}</p>
                <small>{adbDetail && adbDetail.nom}</small>
              </div>
            </div>
            {isPathAuthorizedForUser("/messages", infoProfil) && (
                <Button className="messageBouton" onClick={handleMessageRedirect} title="Messages">
                  <ChatOutlinedIcon />
                </Button>
            )}
            <Button className="deconnexionBouton" onClick={handleDeconnexion} title="Déconnexion">
              <PowerSettingsNew />
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default HeaderAuthenticated;
